module.exports = __webpack_public_path__ + "assets/img/banner1.79a7b271.jpg";